import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Section, SectionItem, SectionName } from '../components/Chrome';
import Loader from '../components/Loader';
import Toggle from '../components/Toggle';
import { useToast } from '../components/Toast';
import { SPACE } from '../utilities/queries';
import { TOGGLE_EARLY_ACCESS, TOGGLE_PUBLIC } from '../utilities/mutations';
import { useSpaceContext } from '../contexts/space';

const SpaceSettingsPreferencesPage = () => {
  const params = useParams();
  const [loadingEarlyAccess, setLoadingEarlyAccess] = useState(false);
  const [loadingPublicSpace, setLoadingPublicSpace] = useState(false);
  const { spaceVars } = useSpaceContext();
  const { data } = useQuery(SPACE, {
    variables: { slug: params.s, ...spaceVars },
  });
  const [toggleEarlyAccess] = useMutation(TOGGLE_EARLY_ACCESS, {
    variables: { spaceSlug: params.s },
    onCompleted: () => setLoadingEarlyAccess(false),
  });
  const [togglePublic] = useMutation(TOGGLE_PUBLIC, {
    variables: { spaceSlug: params.s },
    onCompleted: () => setLoadingPublicSpace(false),
  });
  const toast = useToast();

  return (
    <>
      <Helmet>
        <title>Preferences</title>
      </Helmet>
      <Section>
        {!data ? (
          <Loader />
        ) : (
          <>
            <SectionName isSecondLevel>Preferences</SectionName>
            <SectionItem>
              <Toggle
                checked={data?.space?.earlyAccess}
                onClick={async () => {
                  setLoadingEarlyAccess(true);
                  try {
                    await toggleEarlyAccess();
                  } catch (error) {
                    toast({ children: error.message });
                  }
                }}
                disabled={loadingEarlyAccess}
              >
                Early access
              </Toggle>
            </SectionItem>
            <SectionItem>
              <Toggle
                checked={data?.space?.public}
                onClick={async () => {
                  setLoadingPublicSpace(true);
                  try {
                    await togglePublic();
                  } catch (error) {
                    toast({ children: error.message });
                  }
                }}
                disabled={loadingPublicSpace}
              >
                Public space
              </Toggle>
            </SectionItem>
            <SectionItem isWell>
              Anyone with a link can view a public space.
            </SectionItem>
          </>
        )}
      </Section>
    </>
  );
};

export default SpaceSettingsPreferencesPage;
